import { PipeTransform } from "@angular/core";
import { DefinitionDisplayMode } from "@logex/framework/lg-application";
import { StringKeyOf } from "@logex/framework/types";
import { AppDefinitions } from "../app-definitions.service";
import { IAppDefinitions } from "../app-definitions.types";

// eslint-disable-next-line @typescript-eslint/class-name-casing
export class AsPipeBase implements PipeTransform {

    constructor(
        protected _appDefinitions: AppDefinitions,
        protected _definitionName: StringKeyOf<IAppDefinitions>
    ) { }

    // Note: we could add caching here, but normally we expect the pipe is pure; and if not it probably has a reason and doesn't want to be cached

    transform( value: any, format?: DefinitionDisplayMode, empty?: string ): any {

        if ( value == null ) return empty;

        return this._appDefinitions.getDisplayName( this._definitionName, value, format );
    }
}
